import { render, staticRenderFns } from "./additionals.vue?vue&type=template&id=67293e3e&scoped=true"
import script from "./additionals.vue?vue&type=script&lang=js"
export * from "./additionals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67293e3e",
  null
  
)

export default component.exports